export default __webpack_public_path__ + "static/media/medium.7f69de31.svg";